import React, {Fragment} from 'react'
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import FormControlBase from "./FormControl";
import Icon from "../Icon";

const classNames = require('classnames');

class MainButton extends FormControlBase {
    render = () => {
        const className = this.props.className;
        const size = this.getSizeFromProps();
        const type = this.getColorFromProps();
        const componentClass = this.getComponentClassName();
        const classes = classNames(size, type, componentClass, className);
        const {onClick, disabled} = this.props;

        return (
            <Button variant={"none"} disabled={disabled} className={classes} onClick={onClick}>
                {this.renderContent()}
            </Button>
        );
    };

    renderContent = () => {
        const {text} = this.props;
        return text;
    };


    static propTypes = {
        // The text that will appear in the header.
        // text: PropTypes.string.isRequired,
    };
}

class ButtonWithIcon extends MainButton {
    renderContent = () => {
        const {text, icon, svg} = this.props;
        return (
            <Fragment>
                <Icon icon={icon} svg={svg}/>
                <span className="text">{text}</span>
            </Fragment>
        );
    };

    getComponentClassName = () => 'with-icon';
}

class ButtonWithBadge extends MainButton {
    renderContent = () => {
        const {icon, svg} = this.props;

        return (
            <Fragment>
                {
                    icon ? (
                        <FontAwesomeIcon icon={icon}/>
                    ) : null
                }

                {
                    svg ? (
                        <img src={svg} alt=""/>
                    ) : null
                }
                {this.renderBadge()}
            </Fragment>
        )
    };

    renderBadge = () => {
        let {counter} = this.props;
        if (counter && counter > 0) {
            if (counter > 99)
                counter = "+99";

            return (
                <a className="badge">
                    <small>{counter}</small>
                </a>
            );
        }
    };

    getComponentClassName = () => 'with-badge-icon';


}


export default MainButton;
export {ButtonWithIcon, ButtonWithBadge};
